import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUserProfile } from "../../../store/rootReducer";
import './AccountSettingsPage.scss';
import ActionLink from "../../link/ActionLink";
import ClickableDiv from "../../button/ClickableDiv";
import { RouteConstants } from "../../route/services/RouteConstants";

class AccountSettingsPage extends Component {
  constructor(props) {
    super(props);

      this.state = {
      showAccountSettingsPage: true
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      if (this.props.location.pathname !== RouteConstants.PROFILE) {
        this.setState({
          showAccountSettingsPage: true
        });
      }
    }
  }

  goToProfile = () => {
    this.setState({
      showAccountSettingsPage: false
    });
    this.props.history.push(RouteConstants.PROFILE);
  };

  render() {
    return (
      <div>
        <ClickableDiv
          className="account-dropdown-toggle"
          onClick={() => {
            if (this.state.showAccountSettingsPage) {
              this.goToProfile();
            }
          }}
        >
          <i className="la la-gear" />
          <ActionLink text="navbar.account_settings" />
        </ClickableDiv>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userProfile: getUserProfile(state)
  };
};

export default connect(mapStateToProps)(AccountSettingsPage);